import { HttpInterceptorFn } from '@angular/common/http';
import { isLisaApiRequest } from './interceptor.utils';

/** Send cookies on Lisa API requests (httpOnly session). */
export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isLisaApiRequest(req.url)) {
    return next(req);
  }

  return next(req.clone({ withCredentials: true }));
};
